module.exports = __webpack_public_path__ + "img/level_ID.52c538bc.png";